// extracted by mini-css-extract-plugin
export var black_text = "styles-module--black_text--7a7be";
export var buttonWrapper = "styles-module--button-wrapper--71a70";
export var container = "styles-module--container--0576a";
export var firstGlow = "styles-module--first-glow--390d3";
export var input_container = "styles-module--input_container--d2555";
export var secondGlow = "styles-module--second-glow--8afe2";
export var subscribe_button = "styles-module--subscribe_button--1319d";
export var white_text = "styles-module--white_text--5ccf3";